import { STATUS_TYPE } from '../../../enum';
import { PropertyCategory } from '../../propertyCategory/api/interface';
import { PropertySubCategory } from '../../propertySubCategory/api/interface';

export interface GetPropertyFeature {
  id: string;
}

export interface FindPropertyFeature {
  activeOnly?: boolean;
  search?: string;
  propertyCategoryId?: string;
  propertySubCategoryId?: string;
  limit?: number;
  skip?: number;
}

export interface CreatePatchPropertyFeature {
  id?: string;
  labelEn: string;
  labelAr: string;
  subLabelEn: string;
  subLabelAr: string;
  position: string;
  icon: string;
  activeState: boolean;
  isSmallInputField: boolean;
  propertyCategoryIds: string[];
  propertySubCategoryIds: string[];
}

export interface PropertyFeature {
  id: string;
  labelEn: string;
  labelAr: string;
  subLabelEn: string;
  subLabelAr: string;
  position: string;
  icon: string;
  activeState: boolean;
  isSmallInputField: boolean;
  propertyFeatureId: string[];
  createdBy: string;
  updatedBy: string;
  updatedAt: string;
  createdAt: string;
  propertyFeatureMapper: PropertyFeatureMapper[]
  propertyFeatureSubCategoryMapper: PropertySubFeatureMapper[];
}

export interface PropertyFeatureMapper {
  id: string;
  propertyFeatureId: string;
  propertyCategoryId?: string,
  property_category: PropertyCategory;
}


export interface PropertySubFeatureMapper {
  id: string;
  propertyFeatureId: string;
  propertySubCategoryId?: string,
  property_sub_category: PropertySubCategory;
}


interface InitialState {
  data: PropertyFeature[];
  skip: number;
  limit: number;
  totalRecords: number;
  currentPage: number;
  status: STATUS_TYPE;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  errorMessage: string;
}

export const initialState: InitialState = {
  data: [],
  skip: 0,
  limit: 25,
  totalRecords: 0,
  currentPage: 0,
  status: 'idle',
  isError: false,
  isLoading: false,
  isSuccess: false,
  errorMessage: '',
};